export const colors = {
  primary: '#45d0c1',
  purple: '#8553f4',
  wisteria: '#a97ed1',
  purpleLight: '#CFBAFF',
  yellow: '#FFE268',
  red: '#FF7D78',
  blue_light: '#c5ecff',
  blue: '#1FB6FF',
  blue_hover: '#16a4e8',
  darkBlue: '#34495E',
  linkBlue: '#3eb6ff',
  ultraLightGray: '#f5f5f5',
  lightGray: 'rgba(0, 0, 0, 0.1)',
  gray: 'rgba(0, 0, 0, 0.4)',
  darkGray: 'rgba(0, 0, 0, 0.7)',
  black: 'rgba(0, 0, 0, 0.9)',
  white: '#ffffff',
  border: 'rgba(0, 0, 0, 0.2)',
  avatarBg: '#e1e7ea',
  avatarText: '#7d97ad',

  // new colors
  gray05: '#F2F4F5',
  gray1: '#DFE5E9',
  gray4: '#9EAEB7',
  gray5: '#F5F5F5',
  gray7: '#53656F',
  gray9: '#293841',
  arvore: '#45D0C1',
  orange: '#FFAA68',
  purpleHover: '#6b42c7',

  purple3: `hsl(271, 47%, 66%)`,
  paleGrayFour: '#f3f6fd',
  black6: `hsl(240, 1%, 18%)`,
  black5: `hsl(220, 2%, 35%)`,
  black4: `hsl(228, 2%, 54%)`,
  black3: `hsl(223, 5%, 71%)`,
  black2: `hsl(218, 14%, 89%)`,
  black1: `hsl(220, 69%, 97%)`,
  black01: `rgba(0, 0, 0, 0.1)`, //ask designer why
  red1: `hsl(0, 86%, 97%)`,
  red2: `hsl(0, 100%, 82%)`,
  purple2: `hsl(271, 66%, 84%)`,
  orange1: `hsl(17, 100%, 97%)`,
  orange2: `hsl(17, 100%, 89%)`,
  orange3: `hsl(17, 100%, 74%)`,
  red3: `hsl(0, 93%, 65%)`,

  // reading get us closer colors
  bannerPurple: '#cfbaff',
  gray10: '#9eaeb7',
  gray11: '#dfe5e9',
  gray12: '#53656f'
}

export const sizes = {
  radius: 5,
  // Old sizes
  text: 16,
  smallText: 13,
  smallScreen: 768,
  mediumScreen: 992,
  bigScreen: 1280,
  // New sizes *Use this ones*
  h: {
    1: 40,
    2: 30,
    3: 22,
    4: 18,
    5: 16
  },
  bodySmall: 12.8,
  paragraphSmall: 13,
  paragraph: 15,
  tableHeader: 11,
  label: 13,
  buttonText: 15,
  xxsScreen: 350,
  xsScreen: 480,
  sScreen: 768,
  mScreen: 992,
  lScreen: 1200,
  xlScreen: 1600
}
